import { APIRequestStatus } from 'core/constants/redux';
import { IDateRangeTypes, RelativeDateRanges } from 'core/constants/date';
import { ArchivalRequestMode } from 'core/models/archival';
import { archivalNamespaces } from 'components/feature/Archival/archival.constants';
import {
  ArchivalActionTypes, ArchivalView, IArchivalFormState, IArchivalState,
} from './archival-store.state';

const [firstNamespace] = archivalNamespaces;

const defaultForm: IArchivalFormState = {
  // preselected so the form is usable in one click
  namespace: firstNamespace?.Namespace ?? '',
  mode: ArchivalRequestMode.Keep,
  rangeType: IDateRangeTypes.Relative,
  duration: RelativeDateRanges.LastOneYear,
  from: '',
  to: '',
};

const initialArchivalState: IArchivalState = {
  requestProcessing: {
    [ArchivalActionTypes.CREATE_ARCHIVAL_REQUEST]: APIRequestStatus.AboutToLoad,
    [ArchivalActionTypes.GET_ARCHIVAL_REQUESTS]: APIRequestStatus.AboutToLoad,
    [ArchivalActionTypes.TRIGGER_EXPORT_REQUEST]: APIRequestStatus.AboutToLoad,
    [ArchivalActionTypes.GET_EXPORT_LIST_REQUEST]: APIRequestStatus.AboutToLoad,
    [ArchivalActionTypes.GET_RECORD_REQUEST]: APIRequestStatus.AboutToLoad,
  },
  view: ArchivalView.Request,
  requestForm: { ...defaultForm },
  // exports read archived data back out, so the period is what was archived
  exportForm: { ...defaultForm, mode: ArchivalRequestMode.Archive },
  search: { namespace: firstNamespace?.Namespace ?? '', recordId: '' },
  requests: [],
  exports: [],
  record: null,
  isRecordNotFound: false,
  isRecordLookupUnavailable: false,
  submitError: '',
};

export default initialArchivalState;
